import { useChat } from '~/stores/use-chat/useChat';

export const useShouldShowContextButton = (messageIndex: number) => {
  const { documentContextMessages, messages } = useChat(state => ({
    documentContextMessages: state.documentContextMessages,
    messages: state.messages,
  }));
  const message = messages[messageIndex];
  const contextMessageIdx = message
    ? documentContextMessages.findIndex(m => m.id === message.id)
    : -1;
  const isContinuingMessage = contextMessageIdx > 0;
  return isContinuingMessage;
};
